<template>
  <div class="question-wrap">
    <div class="question-content">
      <div class="question-container">
        <h1 class="question-title">智能公共法律服务
          <el-popover placement="left-end" title="" width="400" trigger="hover">
            <div class="step-wrap">
              <div class="step-title">
                <img src="../../static/img/step.png" alt="">
                <h4>步骤流程</h4>
              </div>
              <div class="step-content">
                <img src="../../static/img/line.png" alt="">
                <ul>
                  <li>
                    <div class="step-content-left">
                      <h5>01</h5>
                    </div>
                    <div class="step-content-right">
                      <p>用户数据需要咨询的问题</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>02</h5>
                    </div>
                    <div class="step-content-right">
                      <p>系统自动给出问题分类与关键事实信息</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>03</h5>
                    </div>
                    <div class="step-content-right">
                      <p>需要额外信息，系统交互式对用户进行提问</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>04</h5>
                    </div>
                    <div class="step-content-right">
                      <p>系统根据事实进行推理，得到所需问题答案</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>05</h5>
                    </div>
                    <div class="step-content-right">
                      <p>结果以咨询报告的形式向用户呈现</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <el-button type="text" slot="reference">步骤流程</el-button>
          </el-popover>
        </h1>
        <div class="question-body" v-show="getRequestType === 'question'">
          <div class="question-body-left">
            <div class="question-body-left-wrap">
              <h5>样例问题:</h5>
              <div class="question-example-wrap">
                <div class="question-example-item" v-for="(item, index) in exampleList" :key="index" @click="chooseExample(index)">
                  <p>{{item}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="question-body-right">
            <div class="question-content-top">
              <el-input type="textarea" :rows="6" placeholder="请输入您的法律问题" v-model="questionData.prologue" style="color: #333; font-size: 16px;"></el-input>
              <el-button type="primary" size="small" @click="getDomiansFunc">立即咨询</el-button>
            </div>
          </div>
        </div>

        <div class="question-body" v-show="getRequestType === 'domain'">
          <div class="question-body-domain">
            <div class="rebort-question">
              <div class="rebort-question-left">
                <img src="../../static/img/rebort.png" alt="">
              </div>
              <div class="rebort-question-right">
                <p>根据您的描述，您是否想咨询以下问题？</p>
              </div>
            </div>
            <div class="rebort-response">
              <div class="rebort-response-left">
                <img src="../../static/img/znrebort.png" alt="">
              </div>
              <div class="rebort-response-right">
                <el-radio-group v-model="questionData.domain" @change="chooseDomainItem" v-if="getRequestType === 'domain' && terminalsList.length === 0">
                  <el-radio :label="item" v-for="(item, index) in domainsList" :key="index" :disabled="item.disabled">{{item.name}}</el-radio>
                </el-radio-group>
                <el-radio-group v-model="questionData.subdomain" @change="getFactorsFunc" v-if="terminalsList.length > 0">
                  <el-radio :label="item" v-for="(item, index) in terminalsList" :key="index">{{item}}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div v-show="getRequestType === 'tells'" class="question-body">
          <div class="question-body-left">
            <div id="graph" style="width:100%; height:100%"></div>
          </div>
          <div class="question-body-right">
            <div class="rebort-question-wrap">
              <div v-if="askQuestion.facet">
                <div class="rebort-chat-wrap">
                  <div class="rebort-header">
                    <p v-show="!beginGetTells">秘塔法律机器人</p>
                    <div class="header-loading" v-show="beginGetTells">
                      <p>对方正在输入中&nbsp;</p>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div class="rebort-content"></div>
                </div>
                <div class="rebort-footer">
                  <el-radio-group v-model="questionData.tells" @change="chooseTellItem" v-show="showChooseBtn">
                    <el-radio :label="true" :disabled="beginGetTells">是</el-radio>
                    <el-radio :label="false" :disabled="beginGetTells">否</el-radio>
                  </el-radio-group>
                </div>
              </div>


              <!-- <div v-if="askQuestion.facet">
                <div class="rebort-question">
                  <div class="rebort-question-left">
                    <img src="../../static/img/rebort.png" alt="">
                  </div>
                  <div class="rebort-question-right">
                    <pre v-show="!beginGetAsk">{{askQuestion.facet}}</pre>
                    <div v-show="beginGetAsk" class="rebort-question-right-wrap">
                      <div class="rebort-question-list">
                        <pre v-for="(item, index) in tells.factors2ask" :key="index">{{item.facet}}</pre>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rebort-response">
                  <div class="rebort-response-left">
                    <img src="../../static/img/znrebort.png" alt="">
                  </div>
                  <div class="rebort-response-right">
                    <el-radio-group v-model="questionData.tells" @change="chooseTellItem">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                    <div class="madols" v-show="beginGetTells">
                      <p>推理中......</p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <!-- <div v-if="tells.terminate">
              <el-button size="small" style="font-size: 16px;" @click="reloadPage">返回首页</el-button>
              <el-button size="small" style="font-size: 16px;" @click="submitReport">生成报告</el-button>
            </div> -->
          </div>
        </div>
        
        <div class="question-content-footer">
          <p>北京大学法律人工智能实验室 & 秘塔科技</p>
          <p>公共法律助手已累计提供<span>801,517</span>人次法律服务</p>
        </div>

      </div>
    </div>

    <!-- loading加载动画 -->
    <div class="loading-wrap" v-if="loading">
      <div class="loader">
        <div class="text">Loading...</div>
        <div class="horizontal">
          <div class="circlesup">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
          <div class="circlesdwn">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </div>
        <div class="vertical">
          <div class="circlesup">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
          <div class="circlesdwn">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成报告界面 -->
    <el-dialog title="" :visible.sync="reportVisible" width="70%" class="report-visible-wrap">
      <div class="">
        <h2>法律咨询报告</h2>
        <div>
          <pre>{{reportTxt}}</pre>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

  </div>
</template>

<script>
import echarts from 'echarts'
import * as _ from 'lodash'
import dataTool from '../../static/js/dataTool.min.js'
import { getDomains, getFactors, getGraph, getTells, createReport, getAsk } from '@/api/api'
export default {
  name: 'question',
  data () {
    return {
      getRequestType: 'question',
      domainsList: [],
      terminalsList: [],
      chooseDomain: '',
      questionData: {
        prologue: '昨天发现老婆居然在吸毒，我跟她提离婚，结果她说已经怀上了，怎么办，也不知道是不是我的，我可以离婚吗？收养送养,分房产',
        domain: '',
        subdomain: '',
        yes: [],
        no: [],
        ask: 1,
        tells: null
      },
      tells: {},
      exampleList: [
        '我们已经结婚登记了，有一个孩子，我发现老公不做家务，我可以离婚吗？',
        '昨天发现老婆居然在吸毒，我跟她提离婚，结果她说已经怀上了，怎么办，也不知道是不是我的，我可以离婚吗？',
        '我想离婚，我要分财产，我还想要孩子抚养权，房子一起首付，我该怎么办？收养送养,分房产'
      ],
      loading: false,
      beginGetTells: false,
      beginGetAsk: false,
      askQuestion: {},
      reportVisible: false,
      reportTxt: '就卡萨回复的开机登上发货单费会计师加水电费金卡戴珊发斯柯达交话费收款机还发萨克斯肯德基后方可手机号非单身看',
      askQuestionData: [],
      showChooseBtn: true
    }
  },
  created () {
    
  },
  methods: {
    reloadPage: function () {
      location.reload()
    },
    getDomiansFunc: function () {
      let _this = this
      let params = {
        prologue: this.questionData.prologue
      }
      getDomains(params).then(res => {
        if (res.data.code === 0) {
          this.getRequestType = 'domain'
          _.forEach(res.data.domains, (o) => {
            if (o.name.indexOf('离婚问题') !== -1 || o.name.indexOf('抚养权问题') !== -1 || o.name.indexOf('收（送）养问题') !== -1 || o.name.indexOf('离婚财产问题') !== -1) {
              o.disabled = false
              _this.domainsList.push(o)
            } else {
              o.disabled = true
              _this.domainsList.push(o)
            }
          })
        } else {
          console.log('获取类别列表失败', res)
        }
      }).catch(res => {
        console.log('获取类别列表失败', res)
      })
    },
    getFactorsFunc: function () {
      this.loading = true
      let _this = this
      let params = {
        prologue: this.questionData.prologue,
        domain: this.questionData.domain.name
      }
      getFactors(params).then(res => {
        if (res.data.code === 0) {
          _.forEach(res.data.factors, (p) => {
            if (p.value === 'true') {
              _this.questionData.yes.push(p.name)
            } else if (p.value === 'false') {
              _this.questionData.no.push(p.name)
            }
          })
          this.getTellsFunc()
        } else {
          console.log('获取要素失败', res)
        }
      }).catch(res => {
        console.log('获取要素失败', res)
      })
    },
    chooseExample: function (index) {
      this.questionData.prologue = this.exampleList[index]
    },
    chooseDomainItem: function () {
      if (this.questionData.domain.subdomains && this.questionData.domain.subdomains.length > 0) {
        this.terminalsList = this.questionData.domain.subdomains
      } else {
        this.loading = true
        this.getFactorsFunc()
      }
    },
    chooseTellItem: function () {
      let _this = this
      if (this.tells.facts) {
        if (this.tells.facts.yes) {
          _.forEach(this.tells.facts.yes, (o) => {
            _this.questionData.yes.push(o.name)
          })
        }
        if (this.tells.facts.no) {
          _.forEach(this.tells.facts.no, (p) => {
            _this.questionData.no.push(p.name)
          })
        }
      }
      let awn = this.questionData.tells ? '是' :'否'
      let awsHtml = ''
          awsHtml += '<div class="rebort-content-user">'
          awsHtml += '<div class="rebort-content-owner-text">'
          awsHtml += '<pre>' + awn + '</pre></div>'
          awsHtml += '<img src="../../static/img/znrebort.png" alt="">'
          awsHtml += '</div>'
      this.$nextTick(() => {
        $('.rebort-content').append(awsHtml)
        $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
      })
      this.getTellsFunc()
    },
    getTellsFunc: function () {
      let _this = this
      this.getRequestType = 'tells'
      this.beginGetTells = true
      if (this.askQuestion.name) {
        if (this.questionData.tells) {
          this.questionData.yes.push(this.askQuestion.name)
        } else {
          this.questionData.no.push(this.askQuestion.name)
        }
      }
      let params = {
        prologue: this.questionData.prologue,
        domain: this.questionData.domain.name,
        subdomain: this.questionData.subdomain,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no)),
        ans: this.askQuestion.name
      }
      getTells(params).then(res => {
        if (res.data.code === 0) {
          this.questionData.tells = null
          if (res.data.tell.facts) {
            if (res.data.tell.facts.yes) {
              _.forEach(res.data.tell.facts.yes, (o) => {
                _this.questionData.yes.push(o.name)
              })
            }
            if (res.data.tell.facts.no) {
              _.forEach(res.data.tell.facts.no, (p) => {
                _this.questionData.no.push(p.name)
              })
            }
          }
          if (res.data.tell.response) {
            let html = ''
                html += '<div class="rebort-content-owner">'
                html += '<img src="../../static/img/rebort.png" alt="">'
                html += '<div class="rebort-content-owner-text">'
                html += '<pre>' + res.data.tell.response + '</pre>'
                html += '</div></div>'
                $('.rebort-content').append(html)
                $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
          }
          this.getGraphFunc()
          if (res.data.tell.terminate) {
            setTimeout(function () {
              _this.tells = res.data.tell
              _this.loading = false
              _this.beginGetTells = false
              _this.beginGetAsk = false
              _this.showChooseBtn = false
              let lastHtml = ''
                  lastHtml += '<div class="rebort-content-owner">'
                  lastHtml += '<img src="../../static/img/rebort.png" alt="">'
                  lastHtml += '<div class="rebort-content-owner-text">'
                  lastHtml += '<pre><a id="retunrToHome">返回首页</a><a id="viewReport">查看报告</a></pre>'
                  lastHtml += '</div></div>'
                  $('.rebort-content').append(lastHtml)
                  $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
                  $('#retunrToHome').on('click', function () {_this.reloadPage()})
                  $('#viewReport').on('click', function () {_this.submitReport()})
            }, 3000)
          } else {
            this.tells = res.data.tell
            this.getAskFuck()
          }
        } else {
          this.getGraphFunc()
          console.log('获取后续问题失败', res.msg)
        }
        this.loading = false
      }).catch(res => {
        console.log('获取后续问题失败', res)
      })
    },
    getAskFuck: function () {
      this.beginGetAsk = true
      // if (this.tells.question) {
      //   if (this.questionData.tells) {
      //     this.questionData.yes.push(this.tells.question.name)
      //   } else {
      //     this.questionData.no.push(this.tells.question.name)
      //   }
      // }
      let params = {
        prologue: this.questionData.prologue,
        domain: this.questionData.domain.name,
        subdomain: this.questionData.subdomain,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no))
      }
      getAsk(params).then(res => {
        this.loading = false
        this.beginGetTells = false
        this.beginGetAsk = false
        if (res.data.code === 0) {
          this.askQuestion = res.data.question
          let askHtml = ''
              askHtml += '<div class="rebort-content-owner">'
              askHtml += '<img src="../../static/img/rebort.png" alt="">'
              askHtml += '<div class="rebort-content-owner-text">'
              askHtml += '<pre>' + res.data.question.facet + '</pre>'
              askHtml += '</div></div>'
          this.$nextTick(() => {
            $('.rebort-content').append(askHtml)
            $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
          })
        } else {
          console.log('获取后续问题失败', res.msg)
        }
      }).catch(res => {
        console.log('获取后续问题失败', res)
      })
    },
    getGraphFunc: function () {
      let _this = this
      let params = {
        prologue: this.questionData.prologue,
        domain: this.questionData.domain.name,
        subdomain: this.questionData.subdomain,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no)),
        gexf: 1
      }
      getGraph(params).then(res => {
        this.initEcharts(res.data)
      }).catch(res => {
        console.log('获取关系图失败', res)
      })
    },
    initEcharts: function (xml) {
      let myChart = echarts.init(document.getElementById('graph')), option
      let graph = echarts.dataTool.gexf.parse(xml)
      var categories = []
        for(var i = 0; i < 9; i++) {
          categories[i] = {
            name: '类目' + i
          }
        }
        graph.nodes.forEach(function(node) {
          node.value = node.symbolSize
          if (node.name.indexOf('非 ') !== -1) {
            node.itemStyle.normal.color = '#2f4553'
          }
          node.ftype = node.attributes.ftype
          if (node.ftype === 'askable') {
            // node.itemStyle.normal.color = '#639fa7'
          } else if (node.ftype === 'terminal') {
            if (node.name.indexOf('非 ') !== -1) {
              node.itemStyle.normal.color = '#2f4553'
            } else {
              node.itemStyle.normal.color = '#c8842f'
            }
            node.symbolSize = 64
          } else if (node.ftype === 'extractable') {
            node.itemStyle.normal.borderWidth = 4
            node.itemStyle.normal.borderColor = '#409EFF'
          } else if (node.ftype === 'internal') {
            
          }
          node.symbolSize /= 1.5;
          node.rule = node.attributes.rule
          node.label = {
            show: true,
            fontSize: 14
          }
          node.category = node.attributes.modularity_class
        })
        option = {
          title: {
            text: '',
            subtext: '',
            top: 'bottom',
            left: 'right'
          },
          tooltip: {
            formatter: function (params, ticket, callback) {
              var rule = ''
              if (params.data.attributes && params.data.attributes.rule) {
                rule = params.data.attributes.rule
                var nameTitle = rule.substr(0, rule.indexOf(' '))
                rule = rule.replace(nameTitle, '<span style="color: #E6A23C; font-weight: 700; font-size: 16px;">' + nameTitle + '</span>')
                rule = rule.replace(/ 且/g, '<span style="color: cyan;"> 且</span>')
                rule = rule.replace(/ 或/g, '<span style="color: cyan;"> 或</span>')
                rule = rule.replace(/非 /g, '<span style="color: cyan;">非 </span>')
                rule = rule.replace(/\\n/g, '<br/>')
              } else {
                rule = ''
              }
              return rule
            },
            position: 'top',
            distance: 20,
            backgroundColor: 'rgba(0, 0, 0, .6)',
            textStyle: {
              color: '#fff',
              fontSize: 14,
              align:'left'
            }
          },
          // legend: [{
          //   data: categories.map(function(a) {
          //     return a.name
          //   })
          // }],
          animationDuration: 1500,
          animationEasingUpdate: 'quinticInOut',
          series: [{
            name: '',
            type: 'graph',
            layout: 'force',
            data: graph.nodes,
            links: graph.links,
            categories: categories,
            roam: true,
            focusNodeAdjacency: true,
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [0, 10],
            symbol: 'circle',
            itemStyle: {
              normal: {
                borderColor: '#fff',
                borderWidth: 1,
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            },
            label: {
              position: 'right',
              formatter: '{b}'
            },
            lineStyle: {
              color: 'source',
              curveness: 0.3,
              width: 3
            },
            emphasis: {
              lineStyle: {
                width: 5
              }
            },
            force: {
              repulsion: 300,
              layoutAnimation : true
            }
          }]
        };
      myChart.setOption(option)
    },
    submitReport: function () {
      let params = {
        domain: this.questionData.domain.name,
        subdomain: this.questionData.subdomain,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no))
      }
      createReport(params).then(res => {
        if (res.data.code === 0) {
          this.reportTxt = res.data.report
          this.reportVisible = true
        } else {
          this.$message({
            type: 'error',
            message: '生成报告失败'
          })
        }
      }).catch(res => {
        this.$message({
          type: 'error',
          message: '生成报告失败'
        })
      })
    }
    
  }
}
</script>

<style lang="less">
  .question-wrap {
    background-image: url(../../static/img/bg.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 100vh;
    position: relative;
    color: #333;
    .question-content {
      background: #fff;
      width: 93vw;
      height: 85vh;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      vertical-align: middle;
      padding: 15px;
      background-image: url(../../static/img/questionbg.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: bottom;
      .question-container {
        position: relative;
        height: 100%;
        .question-title {
          margin-bottom: 2rem;
          position: relative;
          span {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 14px;
            font-weight: normal;
          }
        }
        .question-body {
          display: flex;
          height: 65vh;
          .question-body-left {
            flex: 1;
            position: relative;
            .question-body-left-wrap {
              width: 100%;
              position: absolute;
              top: 50%;
              left: 50%;
              -webkit-transform: translate(-60%, -20%);
              transform: translate(-50%, -60%)
            }
            h3 {
              color: #6e6e6e;
              margin-bottom: 15px;
            }
          }
          .question-body-right {
            width: 500px;
            position: relative;
          }
          h4 {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -65%);
          }
        }
        .question-content-top {
          width: 80%;
          margin: 0 auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-60%, -45%);
          .el-textarea {
            textarea {
              font-size: 16px;
              color: #333;
            }
          }
          .el-button--primary {
            display: block;
            padding: 9px 25px;
            margin: 20px auto 0;
            font-size: 16px;
          }
        }
        .question-example-wrap {
          overflow: hidden;
          text-align: center;
          .question-example-item {
            background-image: url(../../static/img/ex01.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 0;
            width: 150px;
            height: 220px;
            display: inline-block;
            margin-top: 25px;
            cursor: pointer;
            position: relative;
            vertical-align: middle;
            p {
              position: absolute;
              top: 50%;
              padding: 0 12px;
              font-size: 14px;
              left: 0;
              right: 0;
              transform: translateY(-28%);
              line-height: 22px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }
            &:nth-child(2) {
              background-image: url(../../static/img/ex02.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: 0;
              width: 180px;
              height: 250px;
              margin: 0 5%;
              p {
                color: #fff;
                font-size: 15px;
              }
            }
          }
        }
        .question-body-domain {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .rebort-question-wrap {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          transform: translate(-50%, -50%);
          box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
          .rebort-footer {
            padding: 25px 0;
            border-top: 1px solid #ddd;
          }
          .rebort-chat-wrap {
            height: 450px;
            background: #f3f3f3;
            .rebort-header {
              height: 45px;
              line-height: 45px;
              color: #fff;
              background: #3c3c3c;
              .header-loading {
                margin: 0 auto;
                p {
                  display: inline-block;
                }
                span{
                  display: inline-block;
                  width: 5px;
                  height: 5px;
                  margin-right: 5px;
                  border-radius: 50%;
                  background: #fff;
                  -webkit-animation: load 1.04s ease infinite;
                  vertical-align: middle;
                }
                span:last-child{
                  margin-right: 0px; 
                }
                @-webkit-keyframes load{
                  0%{
                    opacity: 1;
                  }
                  100%{
                    opacity: 0;
                  }
                }
                span:nth-child(1){
                  -webkit-animation-delay:0.13s;
                }
                span:nth-child(2){
                  -webkit-animation-delay:0.26s;
                }
                span:nth-child(3){
                  -webkit-animation-delay:0.39s;
                }
                .span:nth-child(4){
                  -webkit-animation-delay:0.52s;
                }
                span:nth-child(5){
                  -webkit-animation-delay:0.65s;
                }
              }
            }
            .rebort-content {
              padding: 0 10px;
              overflow-y: auto;
              height: 400px;
            }
            .el-radio__label {
              font-size: 16px;
            }
            
          }
          .rebort-content-owner {
            text-align: left;
            margin-top: 15px;
            position: relative;
            min-height: 50px;
            img {
              width: 42px;
              height: 42px;
              display: inline-block;
              background: #E6A23C;
              border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
            }
            .rebort-content-owner-text {
              display: inline-block;
              font-size: 14px;
              margin-left: 60px;
              box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
              padding: 10px;
              background: #fff;
              position: relative;
              border-radius: 4px;
              max-width: 250px;
              pre {
                white-space: pre-wrap;
                a {
                  color: #4739bc;
                  display: inline-block;
                  text-decoration: underline;
                  cursor: pointer;
                  &:first-child {
                    margin-right: 10px;
                  }
                }
              }
            }
            .rebort-content-owner-text::before {
              content: '';
              display: block;
              position: absolute;
              width: 0;
              height: 0;
              border-top: 8px solid transparent;
              border-right: 13px solid #fff;
              border-bottom: 8px solid transparent;
              left: -10px;
              top: 11px;
            }
          }
          .rebort-content-user {
            text-align: right;
            margin-top: 15px;
            position: relative;
            min-height: 50px;
            img {
              width: 42px;
              height: 42px;
              display: inline-block;
              background: #409EFF;
              border-radius: 50%;
              position: absolute;
              top: 0;
              right: 0;
              float: right;
            }
            .rebort-content-owner-text {
              text-align: left;
              display: inline-block;
              font-size: 14px;
              margin-right: 60px;
              box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
              padding: 10px;
              background: #fff;
              position: relative;
              border-radius: 4px;
              margin-top: 3px;
            }
            .rebort-content-owner-text::before {
              content: '';
              display: block;
              position: absolute;
              width: 0;
              height: 0;
              border-top: 8px solid transparent;
              border-left: 13px solid #fff;
              border-bottom: 8px solid transparent;
              right: -10px;
              top: 11px;
            }
          }
        }
        .rebort-question {
          overflow: hidden;
          padding: 5px;
          margin-bottom: 20px;
          .rebort-question-left {
            display: inline-block;
            background: #E6A23C;
            float: left;
            padding: 5px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 35px;
            img {
              width: 30px;
              height: 30px;
              vertical-align: middle;
              display: inline-block;
            }
          }
          .rebort-question-right {
            margin-left: 70px;
            text-align: left;
            box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
            border-radius: 4px;
            background: #fff;
            padding: 10px 15px;
            pre {
              white-space: pre-wrap;
              font-size: 16px;
            }
            .rebort-question-right-wrap {
              max-height: 25px;
              overflow: hidden;
              .rebort-question-list {
                animation: moveTop 8s infinite linear;
                -webkit-animation: moveTop 8s infinite linear;
                pre {
                  padding: 5px 0;
                }
              }
              @-webkit-keyframes moveTop {
                0% {
                  transform: translateY(0);
                }
                100% {
                  transform: translateY(-100%);
                }
              }
            }
          }
        }
        .rebort-response {
          overflow: hidden;
          padding: 5px;
          .rebort-response-left {
            float: left;
            display: inline-block;
            background: #409EFF;
            padding: 5px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 35px;
            img {
              width: 30px;
              height: 30px;
              vertical-align: middle;
              display: inline-block;
            }
          }
          .rebort-response-right {
            margin-left: 70px;
            box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
            border-radius: 4px;
            text-align: left;
            background: #fff;
            padding: 15px;
            max-height: 50vh;
            overflow-y: auto;
            position: relative;
            .el-radio {
              margin-bottom: 10px;
              margin-right: 0;
              width: 250px;
            }
            .madols {
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(251, 251, 251, 0.5);
              width: 100%;
              height: 100%;
              text-align: center;
              p {
                position: relative;
                top: 50%;
                margin-top: -11px;
                color: #409EFF;
              }
            }
          }
        }
        .question-content-footer {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          p {
            font-size: 12px;
            color: #7b7b7b;
            span {
              color: #409EFF;
            }
          }
        }
      }
    }
    .loading-wrap {
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, .8);
      z-index: 100;
      .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -mos-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align:center;
      /* disable selection and cursor changes */
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
      }

      /* Text align it the center of screen and connect the looped animation for 2 seconds */
      .text{
        position: absolute;
        left: -1.3em;
        top: -1.7em;
        -webkit-animation: text 2s infinite;
        -moz-animation: text 2s infinite;
        -moz-animation: text 2s infinite;
        -ms-animation: text 2s infinite;
        -o-animation: text 2s infinite;
        animation: text 2s infinite;
      }

      /* Set for the first layer vertical position */
      .vertical{
        position:absolute;
        top: -1.84em;
        left: -0.4em;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
      }

      /* Set for the second layer horizontal position */
      .horizontal{
        position:absolute;
        top:0em;
        left:0em;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      /* The next two classes do mirror for animation */
      .circlesup{
        position:absolute;
        top: -4.7em;
        right: 12.1em;
      }

      .circlesdwn{
        position:absolute;
        top:2.5em;
        right:-13.5em;
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
      }

      /* Create a container for our circles, rotate it 45 degrees and set animation*/
      .circle {
        position: absolute;
        width: 15em;
        height: 15em;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
        -webkit-animation: orbit 2s infinite;
        -moz-animation: orbit 2s infinite;
        -moz-animation: orbit 2s infinite;
        -ms-animation: orbit 2s infinite;
        -o-animation: orbit 2s infinite;
        animation: orbit 2s infinite;
        z-index:5;
      } 

      /* Style's of our circles */
      .circle:after {
        content: '';
        position: absolute;
        width: 2em;
        height: 2em;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        -ms-border-radius: 100%;
        -o-border-radius: 100%;
        border-radius: 100%;
        background: #409EFF; /* Pick a color 1*/
      }

      .circle:nth-child(2) {
        -webkit-animation-delay: 100ms; 
        -moz-animation-delay: 100ms; 
        -ms-animation-delay: 100ms; 
        -o-animation-delay: 100ms; 
        animation-delay: 100ms;
        z-index:4;
      }

      .circle:nth-child(2):after  {
        background: #79d4ee; /* Pick a color 2*/
        -webkit-transform: scale(0.8,0.8);
        -moz-transform: scale(0.8,0.8);
        -ms-transform: scale(0.8,0.8);
        -o-transform: scale(0.8,0.8);
        transform: scale(0.8,0.8);
      }

      .circle:nth-child(3) {
        -webkit-animation-delay: 225ms; 
        -moz-animation-delay: 225ms; 
        -ms-animation-delay: 225ms; 
        -o-animation-delay: 225ms; 
        animation-delay: 225ms; 
        z-index:3;
      }

      .circle:nth-child(3):after  {
        background: #f4d3b0; /* Pick a color 3*/
        -webkit-transform: scale(0.6,0.6);
        -moz-transform: scale(0.6,0.6);
        -ms-transform: scale(0.6,0.6);
        -o-transform: scale(0.6,0.6);
        transform: scale(0.6,0.6);
      }

      .circle:nth-child(4) {
        -webkit-animation-delay: 350ms; 
        -moz-animation-delay: 350ms; 
        -ms-animation-delay: 350ms; 
        -o-animation-delay: 350ms; 
        animation-delay: 350ms; 
        z-index:2;
      }

      .circle:nth-child(4):after  {
        background: #ff6d37; /* Pick a color 4*/
        -webkit-transform: scale(0.4,0.4);
        -moz-transform: scale(0.4,0.4);
        -ms-transform: scale(0.4,0.4);
        -o-transform: scale(0.4,0.4);
        transform: scale(0.4,0.4);
      }


      .circle:nth-child(5) {
        -webkit-animation-delay: 475ms; 
        -moz-animation-delay: 475ms; 
        -ms-animation-delay: 475ms; 
        -o-animation-delay: 475ms; 
        animation-delay: 475ms; 
        z-index:1;
      }

      .circle:nth-child(5):after  {
        background: #DB2F00; /* Pick a color 5*/
        -webkit-transform: scale(0.2,0.2);
        -moz-transform: scale(0.2,0.2);
        -ms-transform: scale(0.2,0.2);
        -o-transform: scale(0.2,0.2);
        transform: scale(0.2,0.2);
      }

      /* Animation keys */
      @-webkit-keyframes orbit {
        0%		{ -webkit-transform:rotate(45deg); } 

        5%		{ -webkit-transform:rotate(45deg);
              -webkit-animation-timing-function: ease-out; } 

        70% { -webkit-transform:rotate(405deg); 
              -webkit-animation-timing-function: ease-in; }

        100%	{ -webkit-transform:rotate(405deg); } 
      }

      @-moz-keyframes orbit {
        0%		{ -moz-transform:rotate(45deg); } 

        5%		{ -moz-transform:rotate(45deg);
              -moz-animation-timing-function: ease-out; } 

        70%		{ -moz-transform:rotate(405deg); 
              -moz-animation-timing-function: ease-in; }

        100%	{ -moz-transform:rotate(405deg); } 
      }
      @-ms-keyframes orbit {
        0%		{ -ms-transform:rotate(45deg); } 

        5%		{ -ms-transform:rotate(45deg);
              -ms-animation-timing-function: ease-out; } 

        70%		{ -ms-transform:rotate(405deg); 
              -ms-animation-timing-function: ease-in; }

        100%	{ -ms-transform:rotate(405deg); } 
      }

      @-o-keyframes orbit {
        0%		{ -o-transform:rotate(45deg); } 

        5%		{ -o-transform:rotate(45deg);
              -o-animation-timing-function: ease-out; } 

        70%		{ -o-transform:rotate(405deg); 
              -o-animation-timing-function: ease-in; }

        100%	{ -o-transform:rotate(405deg); } 
      }

      @keyframes orbit { 
        0%		{ transform:rotate(45deg); } 
        
        5%		{ transform:rotate(45deg);
              animation-timing-function: ease-out; } 

        70% 	{ transform:rotate(405deg); 
              animation-timing-function: ease-in; }

        100%	{ transform:rotate(405deg); } 
      }


      @-webkit-keyframes text {
        0%		{-webkit-transform:scale(0.2,0.2);
            -webkit-animation-timing-function: ease-out; } 

        40%,60%{ -webkit-transform:scale(1,1); 
              -webkit-animation-timing-function: ease-out;  }

        70%,100%{ -webkit-transform:scale(0.2,0.2);  } 
      }

      @-moz-keyframes text {
        0%		{-moz-transform:scale(0.2,0.2);
            -moz-animation-timing-function: ease-out; } 

        50%		{ -moz-transform:scale(1,1); 
              -moz-animation-timing-function: ease-out;  }

        60%		{ -moz-transform:scale(1,1); 
            -moz-animation-timing-function: ease-out;  }

        100%	{ -moz-transform:scale(0.2,0.2);  } 	
      }

      @-mos-keyframes text {
        0%		{-mos-transform:scale(0.2,0.2);
            -mos-animation-timing-function: ease-out; } 

        50%		{ -mos-transform:scale(1,1); 
              -mos-animation-timing-function: ease-out;  }

        60%		{ -mos-transform:scale(1,1); 
              -mos-animation-timing-function: ease-out;  }

        100%	{ -mos-transform:scale(0.2,0.2);  } 
      }

      @-o-keyframes text {
        0%		{ -o-transform:scale(0.2,0.2);
              -o-animation-timing-function: ease-out; } 

        50%		{ -o-transform:scale(1,1); 
              -o-animation-timing-function: ease-out;  }

        60%		{ -o-transform:scale(1,1); 
              -o-animation-timing-function: ease-out;  }

        100%	{ -o-transform:scale(0.2,0.2);  } 
      }

      @keyframes text {
        0%		{ transform:scale(0.2,0.2);
              animation-timing-function: ease-out; } 

        50%		{ transform:scale(1,1); 
              animation-timing-function: ease-out;  }

        60%		{ transform:scale(1,1); 
              animation-timing-function: ease-out;  }

        100%	{ transform:scale(0.2,0.2);  } 
      }
    }
    .report-visible-wrap {
      h2 {
        text-align: center;
        margin-top: -30px;
        margin-bottom: 20px;
      }
      pre {
        white-space: pre-wrap;
      }
    }
  }
  .step-wrap {
    .step-title {
      position: relative;
      img {
        width: 100%;
      }
      h4 {
        position: absolute;
        top: 39px;
        right: 55px;
        font-size: 16px;
      }
    }
    .step-content {
      position: relative;
      overflow: hidden;
      margin-top: -27px;
      padding: 20px 36px;
      ul {
        margin: 0 auto;
        li {
          margin-top: 20px;
          &:nth-child(1) .step-content-left {
            background: #0c1059;
          }
          &:nth-child(2) .step-content-left {
            background: #a74bd4;
          }
          &:nth-child(3) .step-content-left {
            background: #df7ce6;
          }
          &:nth-child(4) .step-content-left {
            background: #e39c64;
          }
          &:nth-child(5) .step-content-left {
            background: #797979;
          }
          .step-content-left {
            float: left;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            z-index: 99;
            position: relative;
            transform: rotate(45deg);
            margin: 5px 0;
            color: #fff;
            h5 {
              transform: rotate(-45deg);
            }
          }
          .step-content-right {
            padding-left: 50px;
            p {
              color: #333;
              font-size: 14px;
              line-height: 30px;
              border-bottom: 1px solid #ddd;
              padding: 5px 0;
            }
          }
        }
      }
      img {
        position: absolute;
        left: 48px;
        width: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Question.vue